/**
 * pages/home.js
 *
 * Enqueued from front-page.php and page-fleviki-aneparkeia.php with:
 *   whytheme_enqueue_script('pages/home');
 *
 * Handles: hero Swiper (home only), factors carousel Swiper + flip cards
 * (home + any page rendering sections/home/factors-carousel). Every init
 * function no-ops when its target markup isn't present on the page.
 */

import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

function initHeroSwiper() {
    const el = document.querySelector('.js-cyclo-hero-swiper');
    if (!el) return;

    new Swiper(el, {
        modules: [Autoplay, Pagination, Navigation],
        spaceBetween: 0,
        slidesPerView: 1,
        loop: el.dataset.loop === '1',
        // autoplay: {
        //     delay: 5000,
        //     disableOnInteraction: false,
        // },
        pagination: {
            el: el.querySelector('.swiper-pagination'),
            clickable: true,
        },
        navigation: {
            prevEl: el.querySelector('.hero-slider-prev'),
            nextEl: el.querySelector('.hero-slider-next'),
        },
    });
}

function initFactorsSwiper() {
    const el = document.querySelector('.js-cyclo-factors-swiper');
    if (!el) return;

    new Swiper(el, {
        modules: [Navigation, Pagination],
        slidesPerGroup: 1,
        watchOverflow: true,
        breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 20 },
            1024: { slidesPerView: 3, spaceBetween: 25 },
        },
        navigation: {
            prevEl: '.factors-carousel-prev',
            nextEl: '.factors-carousel-next',
        },
        pagination: {
            el: '.factors-carousel-pagination',
            type: 'progressbar',
        },
    });
}

function initFactorsFlip() {
    const cards = document.querySelectorAll('.cyclo-factor-card');
    if (!cards.length) return;

    cards.forEach((card) => {
        const front = card.querySelector('.cyclo-factor-card__front');
        const back = card.querySelector('.cyclo-factor-card__back');
        const flipBtn = card.querySelector('[data-cyclo-flip]');
        const backBtn = card.querySelector('[data-cyclo-flip-back]');

        // Cards without back-text are plain links — nothing to flip.
        if (!back || !flipBtn) return;

        const setFlipped = (flipped, moveFocus) => {
            card.classList.toggle('is-flipped', flipped);
            flipBtn.setAttribute('aria-expanded', flipped ? 'true' : 'false');
            // Keep the hidden face out of the tab order / accessibility tree.
            back.inert = !flipped;
            if (front) front.inert = flipped;
            if (moveFocus) {
                (flipped ? backBtn : flipBtn)?.focus();
            }
        };

        // Start on the front face.
        setFlipped(false, false);

        flipBtn.addEventListener('click', () => setFlipped(true, true));
        backBtn?.addEventListener('click', () => setFlipped(false, true));
    });
}

function init() {
    initHeroSwiper();
    initFactorsSwiper();
    initFactorsFlip();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
